var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroceries(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4814_24108)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.625 6.25H19.375C19.7202 6.25 20 6.52982 20 6.875V9.375C20 9.72018 19.7202 10 19.375 10H18.6126L16.2311 19.5263C16.1973 19.6615 16.1193 19.7816 16.0095 19.8675C15.8996 19.9533 15.7642 20 15.6248 20H4.37483C4.23541 20 4.10001 19.9533 3.99016 19.8675C3.88031 19.7816 3.80232 19.6615 3.76858 19.5263L1.38701 10H0.625C0.279822 10 0 9.72018 0 9.375V6.875C0 6.52982 0.279822 6.25 0.625 6.25Z",
    fill: "#CE2600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 17.5C9.83424 17.5 9.67527 17.4342 9.55806 17.3169C9.44085 17.1997 9.375 17.0408 9.375 16.875V13.125C9.375 12.9592 9.44085 12.8003 9.55806 12.6831C9.67527 12.5658 9.83424 12.5 10 12.5C10.1658 12.5 10.3247 12.5658 10.4419 12.6831C10.5592 12.8003 10.625 12.9592 10.625 13.125V16.875C10.625 17.0408 10.5592 17.1997 10.4419 17.3169C10.3247 17.4342 10.1658 17.5 10 17.5Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.875 17.5C6.70924 17.5 6.55027 17.4342 6.43306 17.3169C6.31585 17.1997 6.25 17.0408 6.25 16.875V13.125C6.25 12.9592 6.31585 12.8003 6.43306 12.6831C6.55027 12.5658 6.70924 12.5 6.875 12.5C7.04076 12.5 7.19973 12.5658 7.31694 12.6831C7.43415 12.8003 7.5 12.9592 7.5 13.125V16.875C7.5 17.0408 7.43415 17.1997 7.31694 17.3169C7.19973 17.4342 7.04076 17.5 6.875 17.5Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.125 17.5C12.9592 17.5 12.8003 17.4342 12.6831 17.3169C12.5658 17.1997 12.5 17.0408 12.5 16.875V13.125C12.5 12.9592 12.5658 12.8003 12.6831 12.6831C12.8003 12.5658 12.9592 12.5 13.125 12.5C13.2908 12.5 13.4497 12.5658 13.5669 12.6831C13.6842 12.8003 13.75 12.9592 13.75 13.125V16.875C13.75 17.0408 13.6842 17.1997 13.5669 17.3169C13.4497 17.4342 13.2908 17.5 13.125 17.5Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M3.125 2.5H6.875C7.04076 2.5 7.19973 2.56585 7.31694 2.68306C7.43415 2.80027 7.5 2.95924 7.5 3.125V6.25H2.5V3.125C2.5 2.95924 2.56585 2.80027 2.68306 2.68306C2.80027 2.56585 2.95924 2.5 3.125 2.5Z",
    fill: "#CE2600"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8.125 0H11.875C12.0408 0 12.1997 0.065848 12.3169 0.183058C12.4342 0.300269 12.5 0.45924 12.5 0.625V6.25H7.5V0.625C7.5 0.45924 7.56585 0.300269 7.68306 0.183058C7.80027 0.065848 7.95924 0 8.125 0V0Z",
    fill: "#CE2600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.125 1.25H16.875C17.0408 1.25 17.1997 1.31585 17.3169 1.43306C17.4342 1.55027 17.5 1.70924 17.5 1.875V6.25H12.5V1.875C12.5 1.70924 12.5658 1.55027 12.6831 1.43306C12.8003 1.31585 12.9592 1.25 13.125 1.25Z",
    fill: "#CE2600"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4814_24108"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroceries);
export default __webpack_public_path__ + "static/media/groceries.1842aa13f7a1ac0900714d8f6e8c1a14.svg";
export { ForwardRef as ReactComponent };